import { sendWSPush } from '@/utils/websocket';

/**
 * 交互数据结构：
 * {
 *  topic:'front',
 *  content:JSON.stringify({ command:[{code:'001',等其他参数}]})
 *  //注意：content后面需要为json字符串，command是一个数组，目前只包含一项
 * }
 */

/**
 * code是固定变量，必传，代表每一种交互类型
 */
const bridgeConfig = {};

/**
 * 001视角切换
 * 必viewpoint_code：固定坐标编号
 */
bridgeConfig['c1'] = [{ code: '001', viewpoint_code: `JK001` }];

/**
 * 002热点显示隐藏
 * 必model_code:这里传摄像头编号 all 表示该类型下所有热点,
 * 必type:S1：机电设备、S2：视频监控、S3：安全监测、S4：水情预警、S5：水质预警、S6：设备运行
 * 必state:0 隐藏，1 显示
 */
bridgeConfig['c2'] = [{ code: '002', model_code: `JK002`, type: 'S2', state: 1 }];

/**
 * 003模型高亮
 * 必model_code 这里传设备编号 额外：单个的时候传 'SLJ001' ，多个传'SLJ001,SLJ001'
 * model_code传0 表示高亮去除
 * 必type：
 * T1：电站总览，如果是全亮，则model_code 传 'all',其他规则同上
 * T2：故障诊断，
 * T3：巡检路线，model_code 传路线编号 规则同上
 * T4：工程巡检，
 * T5：电站运维
 * T6: 预警高亮
 */
bridgeConfig['c3'] = [{ code: '003', model_code: `SLJ001`, type: 'T1' }];

/**
 * 004巡检
 * 必lineId:路线编号
 * 必patrol_type: 0或1 0 数据巡检，1 实时巡检 目前只有0
 * 必state: load加载预览 begin开始巡检
 * 非time:30 巡检全程时间 暂无
 * 非pos:xyz(123,123,123) 实时巡检坐标 暂无
 *
 * 停止巡检 lineId:'0',state:'load'
 */
bridgeConfig['c4'] = [
  { code: '004', lineId: 'A01', patrol_type: 0, state: 'load', time: '', pos: '' },
];

/**
 * 005动画播放
 * 必type:
01：水轮机转动
02：水轮机运转
03：拆解动画
04：组装动画
    必：state：动画状态
    play 播放
    stop 暂停
    exit 

 */
bridgeConfig['c5'] = [{ code: '005', type: '01', state: 'play' }];

/**
 * 006天气数据传递
 * 必type 停止下雨 传sun 因为默认是晴天
 * rain 雨
 * snow 雪
 * sun 晴
 * 必 state
 * small 小
 * center 中
 * big 大
 * stop 停止
 */
bridgeConfig['c6'] = [{ code: '006', type: 'rain', state: 'small' }];

/**
 * 007设备运行
 * 必type:'' 预留
 * 必state: play stop exit
 *
 */
bridgeConfig['c7'] = [{ code: '007', type: '', state: 'play' }];

/**
 * 008昼夜控制
 * type:预留
 * 必state:auto昼夜自动切换，move手动滑动条控制
 */
bridgeConfig['c8'] = [{ code: '008', type: '', state: 'move' }];

export function i3DBridge(param) {
  const { type, config } = param;
  const finalType = type || 'c1';
  const finalConfig = {
    command: config || bridgeConfig[finalType],
  };
  sendWSPush({
    topic: 'front',
    content: JSON.stringify(finalConfig),
  });
}

export const i3dActionConfig = [
  {
    code: 'c1',
    name: '视角切换',
    isActive: false,
    config: [{ code: '001', viewpoint_code: `JK001` }],
  },
  {
    code: 'c2',
    name: '热点显示',
    isActive: false,
    config: [{ code: '002', model_code: `JK002`, type: 'S2', state: 1 }],
  },
  {
    code: 'c2',
    name: '热点隐藏',
    isActive: false,
    config: [{ code: '002', model_code: `JK002`, type: 'S2', state: 0 }],
  },
  {
    code: 'c2',
    name: '热点全部显示',
    isActive: false,
    config: [{ code: '002', model_code: `all`, type: 'S2', state: 1 }],
  },
  {
    code: 'c2',
    name: '热点全部隐藏',
    isActive: false,
    config: [{ code: '002', model_code: `all`, type: 'S2', state: 0 }],
  },
  {
    code: 'c3',
    name: '单个高亮',
    isActive: false,
    config: [{ code: '003', model_code: `SLJ001`, type: 'T1' }],
  },
  {
    code: 'c3',
    name: '多个高亮',
    isActive: false,
    config: [{ code: '003', model_code: `SLJ001,SLJ002`, type: 'T1' }],
  },
  {
    code: 'c3',
    name: '全部高亮',
    isActive: false,
    config: [{ code: '003', model_code: `all`, type: 'T1' }],
  },
  {
    code: 'c3',
    name: '全部黑掉',
    isActive: false,
    config: [{ code: '003', model_code: `0`, type: 'T1' }],
  },
  {
    code: 'c3',
    name: '巡检线路高亮',
    isActive: false,
    config: [{ code: '003', model_code: `07`, type: 'T3' }],
  },
  {
    code: 'c3',
    name: '巡检线路高亮关',
    isActive: false,
    config: [{ code: '003', model_code: `0`, type: 'T3' }],
  },
  {
    code: 'c4',
    name: '巡检预览',
    isActive: false,
    config: [{ code: '004', lineId: `07`, patrol_type: '0', state: 'load', time: '', pos: '' }],
  },
  {
    code: 'c4',
    name: '巡检开始',
    isActive: false,
    config: [{ code: '004', lineId: `07`, patrol_type: '0', state: 'begin', time: '', pos: '' }],
  },
  {
    code: 'c5',
    name: '运转动画播放',
    isActive: false,
    config: [{ code: '005', type: '02', state: 'play' }],
  },
  {
    code: 'c5',
    name: '拆解动画播放',
    isActive: false,
    config: [{ code: '005', type: '03', state: 'play' }],
  },
  {
    code: 'c5',
    name: '组装动画播放',
    isActive: false,
    config: [{ code: '005', type: '04', state: 'play' }],
  },
  {
    code: 'c6',
    name: '天气-大雨',
    isActive: false,
    config: [{ code: '006', type: 'rain', state: 'big' }],
  },
  {
    code: 'c6',
    name: '天气-停止',
    isActive: false,
    config: [{ code: '006', type: 'sun', state: '' }],
  },
  {
    code: 'c7',
    name: '设备运行',
    isActive: false,
    config: [{ code: '007', type: '', state: 'play' }],
  },
  {
    code: 'c8',
    name: '昼夜控制-自动',
    isActive: false,
    config: [{ code: '008', type: '', state: 'auto' }],
  },
  {
    code: 'c8',
    name: '昼夜控制-手动',
    isActive: false,
    config: [{ code: '008', type: '', state: 'move' }],
  },
];
